import { useMemo } from "react"

export const useIsCompany = (mode: 'isp' | 'company') => {
  return useMemo(() => mode === 'company', [mode]);
}

export const useIsIsp = (mode: 'isp' | 'company') => {
  return useMemo(() => mode === 'isp', [mode]);
}